







































































































import AppFooter from "@/components/FooterNavigation.vue";
import "./style/app.scss";
import { app } from "@/store";
import { computed, defineComponent, ref } from "@vue/composition-api";
import useServiceUpdate from "@/utilities/useServiceUpdate";

export default defineComponent({
    components: { AppFooter },
    setup() {
        const errorAlert = ref<boolean>(false);
        const successAlert = ref<boolean>(false);
        const alarmAlert = ref<boolean>(false);

        const dismissAlarmAlert = () => {
            app.alarm = "";
        };

        const dismissErrorAlert = () => {
            app.error = "";
        };

        const dismissSuccessAlert = () => {
            app.success = "";
        };

        const title = computed<string>(() => {
            return app.title ? app.title : "";
        });
        const topbar = computed<boolean>(() => {
            return app.showTopBar;
        });
        const footer = computed<boolean>(() => {
            return app.showFooter;
        });
        const error = computed<string>(() => {
            return app.error ? app.error : "";
        });

        const alarm = computed<string>(() => {
            return app.alarm ? app.alarm : "";
        });

        const success = computed<string>(() => {
            return app.success ? app.success : "";
        });
        app.$watch(
            module => module.alarm,
            newValue => {
                alarmAlert.value = newValue != "";
            }
        );
        app.$watch(
            module => module.error,
            newValue => {
                errorAlert.value = newValue != "";
            }
        );
        app.$watch(
            module => module.success,
            newValue => {
                successAlert.value = newValue != "";
            }
        );

        return {
            title,
            topbar,
            footer,
            error,
            alarm,
            success,
            alarmAlert,
            errorAlert,
            successAlert,
            dismissAlarmAlert,
            dismissErrorAlert,
            dismissSuccessAlert,
            ...useServiceUpdate()
        };
    }
});
